export default {
    'onboarding': {
        component: import('@/components/integrations/protokol/monri/Onboarding'),
    }
}